/* ═══════════════════════════════════════
   GLOWHAUS — Complete Theme JS
   ═══════════════════════════════════════ */

(function () {
  'use strict';

  /* ── UTILS ── */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function esc(str) { var d = document.createElement('div'); d.appendChild(document.createTextNode(str || '')); return d.innerHTML; }
  function money(cents) { return '€' + (cents / 100).toFixed(2); }

  /* ── TOAST ── */
  var toastTimer;
  function toast(msg) {
    var el = $('#toast');
    if (!el) return;
    el.textContent = '✓  ' + msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  /* ── CART ── */
  function openCart() {
    $('#cart-drawer').classList.add('is-open');
    $('#cart-overlay').classList.add('is-open');
    document.body.style.overflow = 'hidden';
    $('#cart-open-btn').setAttribute('aria-expanded', 'true');
    refreshCart();
  }

  function closeCart() {
    $('#cart-drawer').classList.remove('is-open');
    $('#cart-overlay').classList.remove('is-open');
    document.body.style.overflow = '';
    $('#cart-open-btn').setAttribute('aria-expanded', 'false');
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
      })
      .catch(function (e) { console.error('Cart refresh failed', e); });
  }

  function updateCartCount(n) {
    $$('#cart-count, #cart-drawer-count').forEach(function (el) {
      if (el.id === 'cart-count') { el.textContent = n; }
      else { el.textContent = n > 0 ? '(' + n + ')' : ''; }
      el.style.transform = 'scale(1.35)';
      setTimeout(function () { el.style.transform = 'scale(1)'; }, 220);
    });
  }

  function renderCartDrawer(cart) {
    var itemsEl = $('#cart-drawer-items');
    var footerEl = $('#cart-drawer-footer');
    var subtotalEl = $('#cart-drawer-subtotal');
    var shippingEl = $('#cart-shipping-note');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer-empty"><p class="cart-drawer-empty-title">Your bag is empty</p><p class="cart-drawer-empty-sub">Discover our Korean skincare edit</p><a href="/collections/all" class="btn-primary" onclick="window.glowhaus.closeCart()">Shop now</a></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (footerEl) footerEl.style.display = 'block';

    // Shipping progress bar
    var FREE_THRESHOLD = 3500; // €35 — matches announcement bar & hero copy
    if (shippingEl) {
      shippingEl.style.display = 'block';
      var pct = Math.min(100, Math.round((cart.total_price / FREE_THRESHOLD) * 100));
      if (cart.total_price >= FREE_THRESHOLD) {
        shippingEl.innerHTML =
          '<div class="cart-shipping-bar-track"><div class="cart-shipping-bar-fill is-complete" style="width:100%"></div></div>' +
          '<p class="cart-shipping-text is-complete">✓ You\'ve unlocked free shipping</p>';
      } else {
        var remaining = money(FREE_THRESHOLD - cart.total_price);
        shippingEl.innerHTML =
          '<div class="cart-shipping-bar-track"><div class="cart-shipping-bar-fill" style="width:' + pct + '%"></div></div>' +
          '<p class="cart-shipping-text">You\'re <strong>' + remaining + '</strong> away from free shipping</p>' +
          '<a href="/collections/sheet-masks" class="cart-shipping-crosssell" onclick="window.glowhaus.closeCart()">Add a sheet mask to get there →</a>';
      }
    }

    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    itemsEl.innerHTML = cart.items.map(function (item) {
      return '<div class="cart-drawer-item">' +
        '<div class="cart-drawer-item-img">' +
          (item.image
            ? '<img src="' + item.image + '" alt="' + esc(item.title) + '" loading="lazy">'
            : '<div class="cart-drawer-item-img-ph">' + esc(item.title.charAt(0)) + '</div>') +
        '</div>' +
        '<div class="cart-drawer-item-info">' +
          '<div class="cart-drawer-item-vendor">' + esc(item.vendor || '') + '</div>' +
          '<div class="cart-drawer-item-title">' + esc(item.product_title) + '</div>' +
          (item.variant_title && item.variant_title !== 'Default Title'
            ? '<div class="cart-drawer-item-variant">' + esc(item.variant_title) + '</div>' : '') +
          '<div class="cart-drawer-item-price">' + money(item.line_price) + '</div>' +
        '</div>' +
        '<div class="cart-drawer-item-qty">' +
          '<button onclick="window.glowhaus.changeQty(\'' + item.key + '\',' + (item.quantity - 1) + ')" aria-label="Decrease">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button onclick="window.glowhaus.changeQty(\'' + item.key + '\',' + (item.quantity + 1) + ')" aria-label="Increase">+</button>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
      });
  }

  function addToCart(variantId, qty, title) {
    qty = qty || 1;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        refreshCart();
        openCart();
        toast((title || item.product_title).split(' ').slice(0, 4).join(' ') + ' added to your bag');
        return item;
      });
  }

  /* ── QUICK ADD BUTTONS ── */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.add-to-cart-btn');
      if (!btn || btn.closest('#product-page-section')) return; // let product page handle its own
      e.preventDefault();
      var variantId = btn.dataset.variantId;
      var title = btn.dataset.productTitle || '';
      if (!variantId) return;
      var original = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      addToCart(variantId, 1, title).finally(function () {
        btn.textContent = original;
        btn.disabled = false;
      });
    });
  }

  /* ── PRODUCT FILTERS ── */
  // Tab switching is handled inline in featured-products.liquid
  function initFilters() {}

  /* ── DROPDOWN MENUS ── */
  function initDropdowns() {
    var wraps = $$('.nav-dropdown-wrap');
    wraps.forEach(function (wrap) {
      var trigger = wrap.querySelector('.nav-dropdown-trigger');
      if (!trigger) return;

      // Hover
      wrap.addEventListener('mouseenter', function () { wrap.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); });
      wrap.addEventListener('mouseleave', function () { wrap.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); });

      // Click/keyboard for accessibility
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = wrap.classList.contains('is-open');
        wraps.forEach(function (w) { w.classList.remove('is-open'); w.querySelector('.nav-dropdown-trigger')?.setAttribute('aria-expanded', 'false'); });
        if (!open) { wrap.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
      });
    });

    // Close on outside click
    document.addEventListener('click', function () {
      wraps.forEach(function (w) { w.classList.remove('is-open'); w.querySelector('.nav-dropdown-trigger')?.setAttribute('aria-expanded', 'false'); });
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        wraps.forEach(function (w) { w.classList.remove('is-open'); });
        closeSearch();
        closeMobileMenu();
        closeCart();
      }
    });
  }

  /* ── SEARCH ── */
  function openSearch() {
    $('#search-overlay').classList.add('is-open');
    setTimeout(function () { $('#search-input').focus(); }, 100);
    document.body.style.overflow = 'hidden';
  }

  function closeSearch() {
    var overlay = $('#search-overlay');
    if (overlay) { overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
  }

  /* ── MOBILE MENU ── */
  function openMobileMenu() {
    $('#mobile-menu').classList.add('is-open');
    $('#mobile-menu-overlay').classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    var m = $('#mobile-menu');
    var o = $('#mobile-menu-overlay');
    if (m) { m.classList.remove('is-open'); }
    if (o) { o.classList.remove('is-open'); }
    document.body.style.overflow = '';
  }

  /* ── MOBILE MENU ACCORDION ── */
  function initMobileMenuAccordion() {
    document.querySelectorAll('.mobile-menu-group-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.mobile-menu-group');
        var isOpen = group.classList.contains('is-open');
        document.querySelectorAll('.mobile-menu-group.is-open').forEach(function (g) {
          if (g !== group) {
            g.classList.remove('is-open');
            g.querySelector('.mobile-menu-group-toggle').setAttribute('aria-expanded', 'false');
          }
        });
        group.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  /* ── STICKY HEADER SHADOW ── */
  function initHeaderScroll() {
    var header = $('#site-header');
    if (!header) return;
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 10 ? '0 2px 24px rgba(44,35,32,0.08)' : '';
    }, { passive: true });
  }

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', function () {
    // Cart
    $('#cart-open-btn')?.addEventListener('click', openCart);
    $('#cart-overlay')?.addEventListener('click', closeCart);
    $('#cart-drawer-close')?.addEventListener('click', closeCart);

    // Search
    $('#search-btn')?.addEventListener('click', openSearch);
    $('#search-close')?.addEventListener('click', closeSearch);
    $('#search-overlay')?.addEventListener('click', function (e) { if (e.target === $('#search-overlay')) closeSearch(); });

    // Mobile menu
    $('#mobile-menu-btn')?.addEventListener('click', openMobileMenu);
    $('#mobile-menu-close')?.addEventListener('click', closeMobileMenu);
    $('#mobile-menu-overlay')?.addEventListener('click', closeMobileMenu);

    initDropdowns();
    initMobileMenuAccordion();
    initQuickAdd();
    initFilters();
    initHeaderScroll();
    refreshCart();

    // Expose for inline scripts
    window.glowhaus = {
      openCart: openCart, closeCart: closeCart,
      refreshCart: refreshCart, addToCart: addToCart,
      changeQty: changeQty, toast: toast
    };
  });

})();
